import React from 'react';
import ReactDOM from 'react-dom/client';

/*
 * Global styles must be imported BEFORE App.
 *
 * ES imports evaluate depth-first, so importing these inside App.js put them
 * after every component stylesheet pulled in via the page tree. Component rules
 * then lost to base.css at equal specificity — `.btn { display: inline-flex }`
 * beat `.nav-cta { display: none }`, leaving the desktop CTA visible next to
 * the mobile hamburger and overflowing the viewport.
 */
import './styles/tokens.css';
import './styles/base.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
